import React from 'react';
import Button from '../../../../components/button';
import { Alert } from '@/components/ui/alert';

import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';

const i18Path = 'employeePage.performanceReview.meeting';

export const SaveChangesButton: React.FC<
  React.PropsWithChildren<{
    isProcessing: boolean;
    disabled?: boolean;
    onClick: () => void;
    label?: string;
    description?: string;
  }>
> = ({ isProcessing, onClick, description, disabled, label }) => {
  const t = useNamespacedTranslation(i18Path);
  return (
    <div>
      <Alert variant="light">
        <p className="text-center">{description}</p>
        <Button
          variant="outline-warning"
          className="mb-3 w-100"
          disabled={disabled}
          label={label ?? t('saveDraft')}
          isProcessing={isProcessing}
          onClick={onClick}
        />
      </Alert>
    </div>
  );
};
